var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"item-text":"text","item-value":"value","items":_vm.items,"label":_vm.$t('common.fields.status'),"value":Number(_vm.value),"clearable":""},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }